<template lang='pug'>
div
  SectionTitle(
    :sectionText="staticData.articlePage.sectionTextVerifiedResult"
    :displayAddButton="displayAddButton"
    @togglePopupAddComment="popupAddEditComment = true"
  )
  span(v-if="comments.length > 0")
    ArticleComment(
      v-for='(comment, idx) in comments'
      :key='idx'
      :idx="idx + 1"
      :comment='comment'
      :staticData="staticData"
      :articleId="articleId"
    )
  span(v-else)
    ArticleWithoutComment
  PopupAddEditComment(v-if="popupAddEditComment" type='add' @closePopup="popupAddEditComment = false" @isSuccess="isSuccess" @isError="isError" :articleId="articleId" sectionText="新增查核")
  PopupContentIconText(v-if="popupContentIconText" @closePopup="popupContentIconText = false" :popupSimpleText="popupSimpleText" :iconType="iconType")
</template>

<script>
import SectionTitle from '@/components/modules/section_title/section_title.vue'
import ArticleComment from '@/components/article_comment/article_comment.vue'
import ArticleWithoutComment from '@/components/article_comment/article_without_comment.vue'
import PopupAddEditComment from '@/components/popup/popup_add_edit_comment.vue'
import PopupContentIconText from '@/components/popup/popup_content_icon_text.vue'

export default {
  components: {
    SectionTitle,
    ArticleComment,
    ArticleWithoutComment,
    PopupAddEditComment,
    PopupContentIconText
  },
  props: {
    comments: Array,
    staticData: Object,
    articleId: Number
  },
  data() {
    return {
      popupAddEditComment: false,
      popupContentIconText: false,
      iconType: "",
      popupSimpleText: ""
    }
  },
  computed: {
    displayAddButton() {
      if (localStorage.getItem(this.$store.state.storageKeys.identity) != 'partners') return false
      let hasCommented = false
      this.comments.forEach(comment => {
        if (comment.partner.id == localStorage.getItem(this.$store.state.storageKeys.id))
          hasCommented = true
      })
      return !hasCommented
    }
  },
  methods: {
    isSuccess() {
      this.popupContentIconText = true
      this.iconType = "complete"
      this.popupSimpleText = "新增完成"
    },
    isError() {
      this.popupContentIconText = true
      this.iconType = "error"
      this.popupSimpleText = "發生錯誤"
    }
  }
}
</script>
